import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { PropertyParser } from './property-parser';
import { ApplicationService } from '../application/application.service';

export class CustomTranslateLoader implements TranslateLoader {


  public constructor(private http: HttpClient, private applicationService: ApplicationService) { }

  public getTranslation(lang: string): Observable<any> {
    const url = `ng-assets/i18n/${lang}.properties?version=${this.applicationService.applicationVersion}`;

    return this.http.get(url, {responseType: 'text'}).pipe(
      map((res: string) => {
        const result: any = PropertyParser.parse(res);
        Object.keys(result).forEach((key: string) => {
          result[key] = (result[key] as string).split('{').join('{{').split('}').join('}}');
        });
        return result;
      }));
  }
}
